export default __webpack_public_path__ + "static/media/flag-uk.b900c9a5.svg";